module.exports = __webpack_public_path__ + "img/symbol_0.60e6301b.png";